import {
  getSecurityRoles,
  getSecurityRolesById,
  getScripts,
  addSecurityRole,
  editSecurityRole,
  deleteSecurityRole,
} from "../../../api/divvy-manageRoles";

const manageRoles = {
  namespaced: true,
  state: () => ({
    securityRolesData: null,
    securityRolesByIdData: null,
    scripts: null,
  }),

  getters: {
    getSecurityRolesData: (state) => {
      return state.securityRolesData;
    },
    getSecurityRolesByIdData: (state) => {
      return state.securityRolesByIdData;
    },
    getScripts: (state) => {
      return state.scripts;
    },
  },

  actions: {
    fetchSecurityRoles({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        getSecurityRoles(params)
          .then((api_data) => {
            resolve(api_data);
            state.securityRolesData = api_data;
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    fetchSecurityRolesById({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        getSecurityRolesById(params)
          .then((api_data) => {
            resolve(api_data);
            state.securityRolesByIdData = api_data;
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    fetchScripts({ state, commit }) {
      return new Promise((resolve, reject) => {
        getScripts()
          .then((api_data) => {
            resolve(api_data);
            state.scripts = api_data;
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    addSecurityRole({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        addSecurityRole(payload)
          .then((api_data) => {
            resolve(api_data);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    editSecurityRole({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        editSecurityRole(payload)
          .then((api_data) => {
            resolve(api_data);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    deleteSecurityRole({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        deleteSecurityRole(params)
          .then((api_data) => {
            resolve(api_data);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    
  },
};

export default manageRoles;
